

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Internal Data State -------------------------------------------

    data: (vm: Vue) => {
        const option = vm.$route.query.option ?? "";
        const signupPackage = vm.$route.query.pkg ?? "";

        return {
            textMessage: "",
            consultation: option === "consultation",
            questions: option === "questions",
            signup: option === "signup" || signupPackage.length > 0,
            signupPackage
        };
    },

    // Computed Properties -----------------------------------------------------

    computed: {

        maxlength (): number {
            return 500;
        },

        /**
         * Format message textarea max length help.
         */
        messageMaxHelp (): string {
            const textMessage = this.textMessage as string;
            const chars   = textMessage.length;

            return `${chars} / ${this.maxlength}`;
        }
    }

    // -------------------------------------------------------------------------

});

